import { gql } from '@apollo/client';
const GET_ORDER_SUPPLIERS_LIST = gql `
  query GetOrderSuppliersList($id: ID!) {
    node(id: $id) {
      ... on OrderNode {
        id
        orderSuppliers(first: 1000) {
          edges {
            node {
              id
              supplier {
                id
                code
                shortName
                fullName
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_ORDER_SUPPLIERS_LIST;
